export default __webpack_public_path__ + "static/media/html.c5341754.png";